module.exports = "./dist/stdassets/images/icons/icon_zoomselect.png";